// FNP-536: form-shape Zod schema for the UsageEvents filter (read-only module). Backend-
// supported fields on UsageEventsFilterInput (FNP-594): accountId, customerId, meterCode,
// unresolvedCustomer, unmetered. The two boolean filters are surfaced as 'true'/'' select
// values — only the truthy ('true') case narrows server-side (buildQueryFilter drops
// falsy values), so the form offers "All" + "Yes" rather than a misleading tri-state.
import {z} from 'zod';

export const FilterFormSchema = z.object({
    accountId: z.string().optional(),
    customerId: z.string().optional(),
    meterCode: z.string().optional(),
    unresolvedCustomer: z.string().optional(),
    unmetered: z.string().optional(),
});
